<as-split direction="horizontal" [gutterSize]="defaultGutterSize" (dragEnd)="onPaneResize($event)">
	<as-split-area size="80">
		<div class="filter-section" [ngClass]="{'filter-section-combine': !tableInfo.hidePaging}">
			<div class="filters-subsection">
				<app-feat-filter-labels-map *ngIf="!hideAttrFilters"></app-feat-filter-labels-map>
				<app-feat-attribute-filter-labels *ngIf="!hideAttrFilters"></app-feat-attribute-filter-labels>
				<app-feat-filter-labels-qacode *ngIf="!hideAttrFilters"></app-feat-filter-labels-qacode>
			</div>
			<div class="table-paging-subsection">
				<app-common-table-paging
					#tablePaging
					[isPaging]="!isMapFilterOn"
					[totalNum]="totalCount"
					[currentRowNum]="rows.length"
					[pageSize]="pageSize"
					(paging)="tableInfo.onPaging($event)">
				</app-common-table-paging>	
			</div>
		</div>
		<div class="table-map-section" [ngClass]="{'table-map-section-combine': !tableInfo.hidePaging}">
			<as-split direction="vertical" [gutterSize]="defaultGutterSize" (dragEnd)="onPaneResize($event)">
				<as-split-area style="position:relative;" size="{{100 - mapSplitRatio}}" order=1>
					<div *ngIf="selectedReport" class="table-section">
						<app-common-datagrid
							#dataTable
							[id]="tableId"
							[columns]="columns"
							[rows]="rows"
							[selectedRows]="selectedRows"
							[isPaging]="false"
							[hidePaging]="true"
							[sortType]="tableInfo.sortType"
							[sorts]="tableInfo.tableSorts"
							[rowClass]="tableInfo.rowClass"
							(select)="tableInfo.onSelect($event)"
							(sort)="tableInfo.onSort($event)"
							(scroll)="tableInfo.onScroll($event)"
							(tableContextmenu)="tableInfo.onContextmenu($event)"
						></app-common-datagrid>
					</div>
					<app-feat-map-controls [mapType]="'report'"></app-feat-map-controls>
				</as-split-area>
				<as-split-area size="{{mapSplitRatio}}" order=2>
					<div class="map-sect">
						<app-common-map
							#analysisMap
							class="analysis-map"
							[mapId]="mapElemId"
							[mapParamsConfig]="mapParamsConfig"
							(contextmenu)="onMapContextmenu($event)">
						</app-common-map>

						<div #BackgroundTooltip [id]="bgTooltipElemId" class="map-tooltip"></div>

					</div>
				</as-split-area>
			</as-split>
		</div>
	</as-split-area>

	<as-split-area size="20">
		<div class="right-container">
			<app-feature-vertical-tabs #verticalTabs [tabs]="tabs" [disableSwitchingTab]="disableTabSwitching" (changeTab)="onChangeTab($event)"></app-feature-vertical-tabs>
		</div>
	</as-split-area>
</as-split>

<ng-template #headerTempl let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
	<div class="datatable-header-cell-wrapper">
		<span class="column-header" appHtmlTooltip [tooltip]="column.info.tooltip">
			{{column.name}}
		</span>
	</div>
</ng-template>
<ng-template #gqpColumnTempl let-row="row" let-value="value">
	<div title="{{row[gqpNoteCol] || ''}}">
		<i *ngIf="value&&value.toLowerCase()==='geom'" class="glyphicons glyphicons-globe"></i>
		<div *ngIf="!value||value.toLowerCase()!=='geom'">{{value}}</div>
	</div>
</ng-template>

<ng-template #tabReportFilter>
	<app-tab-report-filters></app-tab-report-filters>
</ng-template>
<ng-template #tabDataSub>
	<app-interlayer-subject-cards></app-interlayer-subject-cards>
</ng-template>
<ng-template #tabDataRef>
	<app-interlayer-ref-cards></app-interlayer-ref-cards>
</ng-template>
<ng-template #tabException>
	<!-- <app-qc-exceptions *ngIf="cardSelectedRecord&&cardSelectedRecord[exceptionColName]" [recordExceptions]="cardSelectedRecord[exceptionColName]" (onDeleted)="onDeleteException()"></app-qc-exceptions> -->
</ng-template>